import { TabBar } from 'src/types';

// 全局作用域扩展 Window 声明
declare global {
  interface Window {
    [MA_GLOBAL_KEY]: typeof globalConfig;
    simulatorWebkit: any;
    __simulatorConfig__: any;
    logicLayer: any;
  }
}

export const CURRENT_ROUTE = Symbol(`currentRoute`);
export const IS_INITD = Symbol(`isInitd`);
export const TABBAR = Symbol(`tabBar`);
export const CAN_NAVIGATE_TO = Symbol(`canNavigateTo`);

// 为了调试方便, 这里使用字符串常量 而不是 symbol 变量
// TODO: 后期增加 __DEV__ 能力之后, 生产态使用 Symbol
const MA_GLOBAL_KEY = `__ma__global__`;

type GLOBAL_CONFIG_VAL = string | boolean | TabBar | null;

const globalConfig: Record<symbol, GLOBAL_CONFIG_VAL> = {
  [CURRENT_ROUTE]: ``,
  [IS_INITD]: false,
  [TABBAR]: null,
  [CAN_NAVIGATE_TO]: true
};

/**
 * 将变量和值挂到 window 上方便共享
 * 统一挂到 window.__ma__global__对象下, 相同的 key 会被覆盖
 */
window[MA_GLOBAL_KEY] = globalConfig;

export function makeGlobal(key: symbol, val: GLOBAL_CONFIG_VAL): void {
  globalConfig[key] = val;
}

export function getGlobal(key: symbol): GLOBAL_CONFIG_VAL {
  return window[MA_GLOBAL_KEY][key];
}
